/* eslint-disable no-restricted-syntax */
const findItemByIdFromArray = (arr, keyName, value) => {
    for (const index in arr) {
        if (arr[index][keyName] && arr[index][keyName] === value) {
            return index;
        }
    }
    return false;
};

export const findItemValueByIdFromArray = (arr, keyName, value) => {
    const index = findItemByIdFromArray(arr, keyName, value);
    if (index !== false) {
        return arr[index];
    }
    return false;
};

export default findItemByIdFromArray;
